import styled from '@emotion/styled';
import { useRouter } from 'next/router';

import { StandardCarousel } from '../../../../components/carousel/StandardCarousel';

const CAROUSEL_IMAGES = [
  'hub_carousel_flow_1.png',
  'hub_carousel_flow_2.png',
  'hub_carousel_flow_3.png',
];

export const PlansCarousel = () => {
  const router = useRouter();

  const carouselImages = CAROUSEL_IMAGES.map((image, index) => (
    <CarouselImage
      key={`${image}-${index}`}
      src={`${router.basePath}/assets/img/${image}`}
      alt={`Carousel ${index + 1}`}
    />
  ));

  return (
    <StandardCarousel direction="left" animationDuration={50} gap={24}>
      {carouselImages}
    </StandardCarousel>
  );
};

const CarouselImage = styled.img`
  flex-shrink: 0;
  width: auto;
  height: auto;
  max-height: 600px;
  object-fit: contain;
  display: block;
  image-rendering: auto;
`;
